import { Button, Tooltip } from '@mui/material';
import { useFormikContext } from 'formik';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { UploadPropertyOtherDocuments } from 'src/components/ui/UploadDocument';
import AddIcon from '@mui/icons-material/Add';

interface Props {
  documentsKey?: 'additionalDocuments' | 'additionalInvestmentDocuments';
  disabled?: boolean;
}

export const AdditionalDocumentsUploader: FC<Props> = ({ documentsKey = 'additionalDocuments', disabled }) => {
  const { t } = useTranslation();
  const formik = useFormikContext();

  const addClicked = () => {
    const newItem: any = { name: '', src: '' };
    if (documentsKey === 'additionalInvestmentDocuments') {
      newItem.signed = false;
    }
    formik.setFieldValue(`documents.${documentsKey}`, [...additionalDocuments, newItem]);
  };

  const additionalDocuments = (formik.values as any).documents?.[documentsKey] || [];

  return (
    <>
      <>
        {additionalDocuments.map((item: any, index: number) => (
          <UploadPropertyOtherDocuments
            label={t('dashboard.assets.addedit.main.uploadpropertydocuments.fields.additionalDocuments.label')}
            disabled={disabled}
            key={index}
            removeOtherDocument={() => {
              const otherDocuments = additionalDocuments;
              otherDocuments.splice(index, 1);
              formik.setFieldValue(`documents.${documentsKey}`, otherDocuments);
            }}
            name={item.name}
            fileUrl={item.src}
            setName={(name) => {
              const otherDocuments = additionalDocuments;
              otherDocuments[index].name = name;
              formik.setFieldValue(`documents.${documentsKey}`, otherDocuments);
            }}
            setFileUrl={(fileUrl) => {
              const otherDocuments = additionalDocuments;
              otherDocuments[index].src = fileUrl;
              formik.setFieldValue(`documents.${documentsKey}`, otherDocuments);
            }}
            tooltipContent={t('dashboard.assets.addedit.main.uploadpropertydocuments.tooltip')}
          />
        ))}
      </>
      <Tooltip title={disabled ? t('dashboard.assets.addedit.main.uploadpropertydocuments.tooltip') : null}>
        <span>
          <Button variant="contained" startIcon={<AddIcon />} sx={{ marginTop: '16px' }} onClick={addClicked} disabled={disabled}>
            {t('dashboard.assets.addedit.main.uploadpropertydocuments.addmore')}
          </Button>
        </span>
      </Tooltip>
    </>
  );
};
